import useGetBlogPosts from "./useLenderBlogPosts";
import { useStickyState } from "./useStickyState";

const LAST_SEEN_KEY = "releaseNotesLastSeenAt";

export const useNewReleaseNotes = () => {
  const { data: posts } = useGetBlogPosts({
    query: { "data.info.published": true },
    options: { sort: { createdAt: "desc" }, limit: 1 },
  });
  const [lastSeenAt, setLastSeenAt] = useStickyState<string | null>(
    null,
    LAST_SEEN_KEY
  );

  const latestPost = posts?.[0];
  const hasNewReleaseNotes = Boolean(
    latestPost &&
      (!lastSeenAt || new Date(latestPost.createdAt) > new Date(lastSeenAt))
  );

  const markReleaseNotesSeen = () => {
    if (latestPost && latestPost.createdAt !== lastSeenAt) {
      setLastSeenAt(latestPost.createdAt);
    }
  };

  return { hasNewReleaseNotes, markReleaseNotesSeen, latestPost };
};
